var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChannels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    ry: 2.13374,
    rx: 2.13374,
    id: "svg_7",
    cy: 19.71365,
    cx: 11.62305
  }), /*#__PURE__*/React.createElement("line", {
    y2: 19.70669,
    x2: 9.31997,
    y1: 19.70669,
    x1: 1.49768
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1,
    id: "svg_12",
    height: 12.194,
    width: 11.97184,
    y: 2.43452,
    x: 5.88762
  }), /*#__PURE__*/React.createElement("line", {
    y2: 12.60528,
    x2: 8.71196,
    y1: 4.63324,
    x1: 8.71196
  }), /*#__PURE__*/React.createElement("line", {
    y2: 12.5387,
    x2: 11.78923,
    y1: 4.50009,
    x1: 11.78923
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 1.72833,
    rx: 1.68617,
    id: "svg_16",
    cy: 7.37328,
    cx: 13.60187
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.49964,
    x2: 11.74707,
    y1: 14.29563,
    x1: 11.74707
  }), /*#__PURE__*/React.createElement("line", {
    y2: 19.70669,
    x2: 22.90182,
    y1: 19.70669,
    x1: 13.88114
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChannels);
export default __webpack_public_path__ + "static/media/icon-channels.cf2d6b06.svg";
export { ForwardRef as ReactComponent };